@if (haveAuthToken) {
  <div>Logged in, starting Hemisphere...</div>
}

<div style="display:flex;align-items:center;justify-content: center;">
  <div
    style="display: flex; align-items:center; flex-direction: column; width: 430px"
    >
    <img
      style="width: 430px"
      src="../../../assets/img/hemisphere-logo-no-tag.png"
      class="logo"
      alt="Hemisphere logo"
      />

    <a
      href="{{ url }}"
      style="margin-top: 50px; text-align: center"
      class="btn btn-outline-primary btn-outline pull-left confirm"
      >
      <span>Login with SSO</span>
    </a>
  </div>
</div>
